// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2MRvx","filesListContainer":"PosDisputesFiles_filesListContainer__1rtaa","filesButton":"PosDisputesFiles_filesButton__WUmNN"};